import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import EventInfoCard from './EventInfoCard';
import EventReminder from './EventReminder';

// mutations
import AddReminderFoEventMutation from '../../../mutations/AddReminderForEventMutation';
import SubscribeToNewsletterMutation from '../../../mutations/SubscribeToNewsletterMutation';

class EventPendingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reminderResultSuccessful: false,
      showReminderResult: false,
      newsletterResultStatus: null,
      showNewsletterResult: false,
    };
  }

  handleRequestReminder = (email, startnumber, raceletter) => {
    const { pendingEvent, intl, relay } = this.props;
    AddReminderFoEventMutation.commit(
      relay.environment,
      email,
      pendingEvent.id,
      intl.locale,
      startnumber,
      (err, status) => {
        if (err) {
          return;
        }
        if (status === 'ok') {
          this.setState({
            reminderResultSuccessful: true,
            showReminderResult: true,
          });
        }
      }
    );
    if (raceletter) {
      this.handleSubscribeToRaceletter(email);
    }
  };

  handleSubscribeToRaceletter = email => {
    const { pendingEvent, intl, relay } = this.props;
    SubscribeToNewsletterMutation.commit(
      relay.environment,
      email,
      intl.locale,
      pendingEvent.sports[0]?.name,
      (err, status) => {
        if (err) {
          return;
        }
        this.setState({
          newsletterResultStatus: status,
          showNewsletterResult: true,
        });
      }
    );
  };

  render() {
    const { pendingEvent, ...rest } = this.props;

    const {
      showReminderResult,
      reminderResultSuccessful,
      showNewsletterResult,
      newsletterResultStatus,
    } = this.state;

    return (
      <div className="row event-pending-container">
        <EventInfoCard eventInfo={pendingEvent} {...rest} />
        <EventReminder
          showReminderResult={showReminderResult}
          reminderResultSuccessful={reminderResultSuccessful}
          showNewsletterResult={showNewsletterResult}
          newsletterResultStatus={newsletterResultStatus}
          onRequestReminder={this.handleRequestReminder}
        />
      </div>
    );
  }
}

EventPendingView.propTypes = {
  bestOfAvailable: PropTypes.bool,
  pendingEvent: PropTypes.object,
  intl: PropTypes.object,
  relay: PropTypes.object,
  onExpandBestof: PropTypes.func,
};

export { EventPendingView };

export default createFragmentContainer(injectIntl(EventPendingView), {
  pendingEvent: graphql`
    fragment EventPendingView_pendingEvent on Event {
      id
      sgId
      sports {
        name
      }
      ...EventInfoCard_eventInfo
    }
  `,
});
